import * as React from 'react';
import ReactDrift from 'react-driftjs';

export default function Drift() {
  return <ReactDrift appId="87z8gftie3cy" />;
}
